module.exports = __webpack_public_path__ + "static/img/cura1.f74f30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/cura1.png
// module id = mj4R
// module chunks = 18